// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shodow[data-v-1fc66078]{position:fixed;top:0;left:0;bottom:0;right:0;background:rgba(0,0,0,.1);z-index:99999}.shodow .loading_content[data-v-1fc66078]{position:absolute;top:50%;left:50%}", ""]);
// Exports
module.exports = exports;
